import { render, staticRenderFns } from "./SaleInvoicesProfileForm.vue?vue&type=template&id=5d4d7cf2&"
import script from "./SaleInvoicesProfileForm.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports